const domain = window.location.origin;
const formbricksURL = process.env.SURVEYS_URL || `${window.location.origin}/api/surveys/`;

// exports.API_BASE_URL = () => {
//     return domain.search("localhost") !== -1
//         ? `${window.location.protocol}//${window.location.hostname}:5002`
//         : `${domain}`;
// };

// exports.API_BASE_URL = () => {
//     return 'https://master.dev.luminoso.com';
// };

// exports.API_BASE_URL = () => {
//     return 'https://dashboards-dev.luminoso.com'
// };


exports.API_BASE_URL = () => {
    return 'https://luminoso-api.intelligaia.com';
};


// exports.API_BASE_URL = () => {
//     return domain.search("localhost") !== -1
//         ? `${window.location.protocol}//${window.location.hostname}:5002`
//         : `${domain}`;
// };

exports.API_FORMBRICKS_URL = () => {
    return domain.search("localhost") !== -1
        ? `${window.location.protocol}//${window.location.hostname}:4000/api/surveys/`
        : formbricksURL;
};
